// ===========================================
// BUSTED! BLACKJACK - ADMIN ROUTE
// ===========================================
// Protects admin-only routes (demo pages, etc.)

import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores';
import bustedLogo from '../assets/busted.png';

interface AdminRouteProps {
  children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading, user } = useAuthStore();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="text-center">
          <img src={bustedLogo} alt="BUSTED!" className="h-28 mx-auto animate-pulse" />
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to home if not admin
  if (!user?.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default AdminRoute;
